import React from 'react';

import { useCheckUserExists, useVerifySignUp } from '@hero/services/organization-service/hooks';

import { Verification } from '../Verification';

function SignUpVerify({ activeStep, signUpData, setSignUpData, setActiveStep }) {
  const { mutateAsync: sendCode } = useVerifySignUp();

  const handleSendCode = async ({ code }) => {
    return sendCode({
      verificationCode: code,
      verificationToken: signUpData.verificationToken
    }).then(async res => {
      setSignUpData({ ...signUpData, registrationToken: res.registrationToken });
      setActiveStep(activeStep + 1);
    });
  };

  const { mutateAsync: checkUserExistence } = useCheckUserExists();

  return (
    <Verification
      contactInfo={signUpData.email}
      onSubmit={handleSendCode}
      onResend={async () => {
        const res = await checkUserExistence({
          email: signUpData.email
        });
        setSignUpData({ ...signUpData, verificationToken: res.verifyToken });
      }}
      onBack={() => setActiveStep(activeStep - 1)}
    />
  );
}

export { SignUpVerify };
